import React from 'react'
import { DashboardTemplate } from '../templates/DashboardTemplate'
import { useRealTimeFeedback } from '../../hooks/useRealTimeFeedback'

interface DashboardPageProps {
  // These could come from API calls or context in a real implementation
  activeFeedbackCount?: number
  totalApplicationsCount?: number
  pendingFeedbackCount?: number
}

export const DashboardPage: React.FC<DashboardPageProps> = ({
  activeFeedbackCount = 0,
  totalApplicationsCount = 0,
  pendingFeedbackCount = 0,
}) => {
  const { getFeedbackCount } = useRealTimeFeedback();
  
  // Use real-time feedback count if available, otherwise fall back to props
  const realTimeFeedbackCount = getFeedbackCount();
  const effectiveActiveFeedbackCount = realTimeFeedbackCount > 0 ? realTimeFeedbackCount : activeFeedbackCount;

  return (
    <DashboardTemplate
      activeFeedbackCount={effectiveActiveFeedbackCount}
      totalApplicationsCount={totalApplicationsCount}
      pendingFeedbackCount={pendingFeedbackCount}
      showThemeDebug={import.meta.env.DEV} // Only show debug info in development
    />
  )
} 